import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ProdutosService } from './../../service/produtos.service';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { ThemePalette } from '@angular/material/core';
import { AlertService } from './../../service/alert.service';
import { ClientesService } from './../../service/clientes.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Cliente } from 'src/app/model/cliente.model';

@Component({
  selector: 'app-atualizar-cliente',
  templateUrl: './atualizar-cliente.component.html',
  styleUrls: ['./atualizar-cliente.component.css']
})
export class AtualizarClienteComponent implements OnInit {

  map?: google.maps.Map;
  latlgn: any;
  cliente: Cliente = {
    sr_id: '',
    vc_cidade: '',
    vc_cnpj: '',
    vc_complemento: '',
    vc_pais: '',
    vc_endereco: '',
    vc_nome: '',
    vc_codigo_postal: '',
    vc_email_responsavel: '',
    vc_nome_responsavel: '',
    vc_estado: '',
    bl_status: false,
    vc_latitude: '',
    vc_longitude: ''
  }
  markers = [] as any;
  latitude: any;
  longitude: any;
  load = false;
  value = 50;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  produtos = [] as any
  form!: FormGroup;

  constructor(private router: Router, 
    private service: ClientesService, 
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private produtoService: ProdutosService,
    private formBuilder: FormBuilder
) { 
  this.form = this.formBuilder.group({
    vc_nome: new FormControl('', [Validators.required]),
    vc_cidade: new FormControl('', [Validators.required]),
    vc_cnpj: new FormControl('', [Validators.required]),
    vc_codigo_postal: new FormControl('', [Validators.required]),
    vc_complemento: new FormControl('', [Validators.required]),
    vc_pais: new FormControl('', [Validators.required]),
    vc_endereco: new FormControl('', [Validators.required]),
    vc_email_responsavel: new FormControl('', [Validators.required, Validators.email]),
    vc_nome_responsavel: new FormControl('', [Validators.required]),
    vc_estado: new FormControl('', [Validators.required]),
    ar_produtos: new FormControl([], [Validators.required])
  })
}

  ngOnInit(): void {
    this.listarProdutos()
    this.listarProdutos()
    this.cliente.sr_id =  this.activatedRoute.snapshot.paramMap.get('sr_id')!;
    this.listarPorId();
  }

  listarPorId(): void{
    this.service.listarIdService(this.cliente.sr_id).subscribe((resp:any) => {
      this.popularForm(resp[0])
      this.latitude = resp[0].vc_latitude;
      this.longitude = resp[0].vc_longitude;
      if(resp[0].vc_latitude !== null || resp[0].vc_longitude !== null) {
        this.map = new google.maps.Map(document.getElementById("map") as HTMLDivElement, {
          center: {lat: parseFloat(resp[0].vc_latitude), lng: parseFloat(resp[0].vc_longitude)},
          mapTypeId: 'satellite',
          zoom: 8,
        });
      } else {
        this.map = new google.maps.Map(document.getElementById("map") as HTMLDivElement, {
          center: { lat: -20.8202, lng: -49.3797 },
          zoom: 8,
          mapTypeId: 'satellite',
        });
      }
      const marker = new google.maps.Marker({
        position: {lat: parseFloat(resp[0].vc_latitude), lng: parseFloat(resp[0].vc_longitude)},
        map: this.map,
      });
      if (resp[0].vc_latitude !== null){
        this.markers.push(marker);
      }
      this.map.addListener("click", (mapsMouseEvent: any) => {
        if(this.markers.length !== 0){
          this.hideMarkers();
          this.markers = [];
        }
        this.latlgn = mapsMouseEvent.latLng
        const marker = new google.maps.Marker({
          position: mapsMouseEvent.latLng,
          map: this.map,
        });
        this.markers.push(marker);
      });
    })
  }

  hideMarkers(){
    this.setMapOnAll(null)
  }

  setMapOnAll(map: google.maps.Map | null) {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(map);
    }
  }

  atualizar(): void {
    if(this.latlgn !== undefined) {
      this.form.value.vc_latitude = this.latlgn.lat()
      this.form.value.vc_longitude = this.latlgn.lng()
    } else {
      if(this.latitude !== null && this.longitude !== null) {
        this.form.value.vc_latitude = this.latitude;
        this.form.value.vc_longitude = this.longitude;
      } else {
        this.alertService.error("Marque a localização da empresa no mapa!");
        return;
      }
    }

    if(this.form.status == "INVALID"){
      return;
    }
    this.load = true
    this.form.value.sr_id = this.activatedRoute.snapshot.paramMap.get('sr_id')!;
    this.service.atualizarService(this.form.value).subscribe(resp => {
      this.load = false
      this.alertService.success();
      this.router.navigate(['configuracao/clientes']);
    }, error => {
      this.load = false
      if(typeof error == 'object'){
        if(typeof error.mensagem == 'string'){
          this.alertService.error(error.mensagem);
        } else {
          this.alertService.error(error.mensagem[0]);
        }
      } else {
        this.alertService.error(error)
      }
    })
  }

  cancel(){
    this.router.navigate(['configuracao/clientes']);
  }

  listarProdutos(){
    this.produtoService.listarService().subscribe((resp:any) => {
      this.produtos = resp.filter(function(elem:any) {
        return elem.sr_id != 1
      })
    },error => {

    })
  }

  popularForm(cliente:any){
    var produtos = [] as any
    cliente.produtos.forEach((element:any) => {
      produtos.push(element.sr_id)
    });
    this.form.get("vc_nome")?.setValue(cliente.vc_nome)
    this.form.get("vc_cidade")?.setValue(cliente.vc_cidade)
    this.form.get("vc_cnpj")?.setValue(cliente.vc_cnpj)
    this.form.get("vc_complemento")?.setValue(cliente.vc_complemento)
    this.form.get("vc_pais")?.setValue(cliente.vc_pais)
    this.form.get("vc_endereco")?.setValue(cliente.vc_endereco)
    this.form.get("vc_codigo_postal")?.setValue(cliente.vc_codigo_postal)
    this.form.get("vc_email_responsavel")?.setValue(cliente.vc_email_responsavel)
    this.form.get("vc_nome_responsavel")?.setValue(cliente.vc_nome_responsavel)
    this.form.get("vc_estado")?.setValue(cliente.vc_estado)
    this.form.get("vc_latitude")?.setValue(cliente.vc_latitude)
    this.form.get("vc_longitude")?.setValue(cliente.vc_longitude)
    this.form.get("ar_produtos")?.setValue(produtos)
  }

}